import { axios, fileAxios } from '../plugins/axios';

export default {
  namespaced: true,

  state: {
    evaluacionesIntegracion: [],
    evaluacionesIntegracionExpediente: [],
  },

  getters: {
    getEvaluacionesIntegracion: (state) => state.evaluacionesIntegracionExpediente,
  },

  mutations: {
    SET_EVALUACIONES_INTEGRACION(state, evaluacionesIntegracion) {
      state.evaluacionesIntegracion = evaluacionesIntegracion;
    },

    SET_EVALUACIONES_INTEGRACION_EXPEDIENTE(state, evaluacionesIntegracionExpediente) {
      state.evaluacionesIntegracionExpediente = evaluacionesIntegracionExpediente;
    },
  },

  actions: {
    async fetchEvaluacionesIntegracion({ commit }) {
      axios
        .get('PoliciaCuadrantes/C3/evaluacionesIntegracion')
        .then((response) => {
          commit('SET_EVALUACIONES_INTEGRACION', response.data.data);
        });
    },

    async fetchEvaluacionesIntegracionByExpediente({ commit }, idExpediente) {
      await axios
        .get(`PoliciaCuadrantes/C3/expedientes/${idExpediente}/evaluacionesIntegracion`)
        .then((response) => {
          commit('SET_EVALUACIONES_INTEGRACION_EXPEDIENTE', response.data.data);
        });
    },

    async saveEvaluacionIntegracion(context, evaluacionIntegracion) {
      await axios
        .post(`PoliciaCuadrantes/C3/expedientes/${evaluacionIntegracion.fk_idExpediente}/evaluacionesIntegracion`, evaluacionIntegracion)
        .then((response) => {
          const formData = new FormData();
          formData.append('file', evaluacionIntegracion.file);
          formData.append('idIntegracion', response.data.data[0].ID);
          context.dispatch('uploadEvaluacionIntegracion', formData);
        });
    },

    async updateEvaluacionIntegracion(_, evaluacionIntegracion) {
      await axios
        .put(
          `PoliciaCuadrantes/C3/expedientes/${evaluacionIntegracion.fk_idExpediente}/evaluacionesIntegracion/${evaluacionIntegracion.id}`,
          evaluacionIntegracion,
        );
    },

    async uploadEvaluacionIntegracion(context, formData) {
      await fileAxios
        .post('/C3/SetAdjuntoIntegraciones/uploadFiles', formData)
        .then(() => {
          context.commit('SET_SNACKBAR_MESSAGE', 'Evaluación de integración guardada correctamente.', {
            root: true,
          });
        });
    },
  },
};
